import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Grid } from 'react-window';
import SpellCard from '@/components/Abilities/Spells/SpellCard';
export const SpellsHorizontalList = ({ spells, handleCardClick, }) => {
    const MemoSpellCard = memo(SpellCard);
    const CellComponent = ({ columnIndex, spells, style, }) => {
        const spell = spells[columnIndex];
        return (_jsx("div", { style: Object.assign(Object.assign({}, style), { padding: 10 }), children: _jsx(MemoSpellCard, { spellData: spell, onCardClick: handleCardClick, styles: { height: 350 } }, spell.index) }));
    };
    const HorizontalList = () => {
        return (_jsx(Grid, { cellComponent: CellComponent, cellProps: { spells }, columnCount: spells.length, columnWidth: 360, rowCount: 1, rowHeight: 370, overscanCount: 5, className: "spells-horizontal-list" }));
    };
    return _jsx(HorizontalList, {});
};
